import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router'
import logo from '../eye-mask.svg'
import insta_icon from '../assets/insta-ico.svg'
import linkedin_logo from '../assets/linkedin-ico.svg'
import RegistrationStore from '../stores/RegistrationStore'
import Loader from './Loader'

export const RegInvite = observer((props: { store: RegistrationStore }) => {

    const history = useHistory()
    const store = props.store

    function getStatus() {

        switch (props.store.inviteProg) {

            case 'INIT': return null
                break;

            case 'LOADING': return <Loader absolute={false} />
                break;

            case 'SUCCESS': return <span className="material-icons" style={{ color: 'green' }}>task_alt</span>
                break;

            case 'FAILED': return <span className="material-icons" style={{ color: 'red' }}>error</span>
        }
    }

    return (
        <div className='flex-column reg-invite center-justify card '  >
            <p style={{ fontSize: 12, textAlign: 'center', top: 5, marginBottom: 8 }} >Your invite code</p>
            <div className='flex-row center-align' style={{ width: '100%' }}  >
                <img src={logo} alt="" style={{ height: 30, width: 40 }} />
                <input type="text" name="" id=""
                    className='input-reg-invite' maxLength={6}
                    onChange={(e) => props.store.setInviteCode(e.target.value)}
                />
                <div style={{ marginLeft: 5 }} >{getStatus()}</div>
            </div>
            <div className='flex-column' style={{margin: 5}} >
                { store.validateInviteResp?.ig && <div className='flex-row center-both'>
                    <img src={insta_icon} alt="" style={{
                        width: 25,
                        height: 25
                    }} />
                    <p style={{fontSize: 12}} >{store.validateInviteResp.ig}</p>
                </div>}
                { store.validateInviteResp?.linked_in && <div className='flex-row center-both'>
                    <img src={linkedin_logo} alt="" style={{
                        width: 25,
                        height: 25
                    }} />
                    <p style={{fontSize: 12}} >{store.validateInviteResp.linked_in}</p>
                </div>}
            </div>
            <p
                onClick={() => history.push('/stapp/needforinvite')}
                style={{ fontSize: 12, textAlign: 'center', bottom: 5, color: 'purple', cursor: 'pointer' }} >Why do I need an invite code?</p>
        </div>
    )
})